import React, {useState} from 'react';

import {Tab, TabContainer} from 'ui-library/TabContainer';

import {LayoutPath, TabSection as TabSectionType} from './DataLayoutTypes';
import GridSection from './GridSection';

interface TabSectionProps {
  layoutPath: LayoutPath;
  tabSection: TabSectionType;
}

/** @package */
export default function TabSection({layoutPath, tabSection}: TabSectionProps): JSX.Element {
  const [activeTab, setActiveTab] = useState<string>('0');

  return (
    <TabContainer<string> activeTab={activeTab} onRequestTabChange={setActiveTab}>
      {tabSection.tabs.map((tab, index) => (
        <Tab tabKey={index.toString()} title={tab.title} key={index}>
          <GridSection gridSection={tab} layoutPath={[...layoutPath, 'tabs', index]} />
        </Tab>
      ))}
    </TabContainer>
  );
}
